var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section"}},[_c('tb',{attrs:{"t-btxt1":_vm.p8ssubtitlep4,"t-btxt2":_vm.p8ssubtitlep5,"t-button1":_vm.p8ssubtitlep6,"t-button2":_vm.p8ssubtitlep7,"t-burl":_vm.p8surl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }